// extracted by mini-css-extract-plugin
export default {"inputLengthLabel":"inputLengthLabel--a4_6d"};